module.exports = __webpack_public_path__ + "static/img/mzsm_font.d04761b9.svg";